import { render, staticRenderFns } from "./MatchingPay.vue?vue&type=template&id=1cd794a9"
import script from "./MatchingPay.vue?vue&type=script&lang=js"
export * from "./MatchingPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports